import React, {useEffect, useState} from "react";
import Form from "~/common/components/Form";
import Select from "~/common/components/Select";

const SelectType = ({ useForm, form, apply, companyInfoData, setCompanyTypeSel }) => {
	const formContent = form.content;
	useEffect(() => {
		useForm.setValue(form.order.toString(), form.answer);
	}, []);

	function setOptions(options) {
		let newOptions = [];
		options.forEach((option) => {
			newOptions.push({ label: option, value: option });
		});
		return newOptions;
	}

	const selectedValue = useForm.watch(form.order.toString());
	// 등록된 기업구분 있으면 등록된 기업구분 set 하고 없으면 기업정보에 있는 기업구분을 set 한다.
	// 단, 기업구분은 최초가 아닌경우 수정해도 기업정보는 수정되지 않는다.
	// @INFO option list set 이후에 일어나야하므로 컴포넌트 내에서 set
	useEffect(() => {
		if(formContent === "type") {
			if(form.answer) {
				useForm.setValue(form.order.toString(), form.answer);
			} else if(companyInfoData?.company?.certType) {
				useForm.setValue(form.order.toString(), companyInfoData.company.certType);
			}
		}
	}, [companyInfoData]);


	useEffect(() => {
		if (formContent === "type") {
			// 선택된 값이 변경될 때마다 실행
			setCompanyTypeSel(selectedValue);
		}
	}, [selectedValue, formContent]);


	return (
		<>
			<Form useForm={useForm} className="radio-form-wrap horiz">
				<Select
					label={form.title}
					name={form.order.toString()}
					options={setOptions(form.selectOption)}
					required={form.required}
					disabled={apply}
				/>
			</Form>
		</>
	);
};

export default SelectType;
